export class M3MastersCategoryReq{
    category: string;
    constructor(category:string){
        this.category = category
    }
}